import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'breadcrumb.labels';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
    private readonly labels$ = new BehaviorSubject<Record<string, string>>(this.load());

    get changes(): Observable<Record<string, string>> {
        return this.labels$.asObservable();
    }

    setLabel(key: string, value: string): void {
        const next = { ...this.labels$.value, [key]: value };
        this.labels$.next(next);
        this.persist(next);
    }

    setScopedLabel(key: string, id: string | number, value: string): void {
        this.setLabel(this.toScopedKey(key, id), value);
    }

    getLabel(key: string): string | undefined {
        return this.labels$.value[key];
    }

    getScopedLabel(key: string, id: string | number): string | undefined {
        return this.getLabel(this.toScopedKey(key, id));
    }

    private toScopedKey(key: string, id: string | number): string {
        return `${key}:${id}`;
    }

    private load(): Record<string, string> {
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch {
            return {};
        }
    }

    private persist(labels: Record<string, string>): void {
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(labels));
        } catch {
            // storage full or unavailable: labels stay in-memory only
        }
    }
}
